import { useEffect, useState } from 'react';

// Sin router: son pocas pantallas. La ruta es el pathname, y el link a un
// torneo (/t/abierto-de-octubre-2026) es el que circula por WhatsApp, asi que
// tiene que ser una direccion de verdad y no un estado interno.

const EVENTO = 'cambio-de-ruta';

export function ir(ruta: string) {
  if (ruta === location.pathname) return;
  history.pushState(null, '', ruta);
  window.dispatchEvent(new Event(EVENTO));
  window.scrollTo({ top: 0 });
}

export function useRuta(): string {
  const [ruta, setRuta] = useState(location.pathname);
  useEffect(() => {
    const actualizar = () => setRuta(location.pathname);
    window.addEventListener('popstate', actualizar);
    window.addEventListener(EVENTO, actualizar);
    return () => {
      window.removeEventListener('popstate', actualizar);
      window.removeEventListener(EVENTO, actualizar);
    };
  }, []);
  return ruta;
}

/** Un <a> que navega sin recargar, pero que sigue siendo un link (se puede copiar o abrir aparte). */
export function alTocar(ruta: string) {
  return (e: { preventDefault: () => void; metaKey?: boolean; ctrlKey?: boolean }) => {
    if (e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    ir(ruta);
  };
}
